var map = {
	"./checkbox-active.svg": 2954,
	"./close.svg": 9335,
	"./footer-logo.svg": 5007,
	"./gifts/gift-1.png": 1023,
	"./gifts/gift-2.png": 7673,
	"./gifts/gift-3.png": 6907,
	"./intro/intro-image.png": 4950,
	"./intro/intro-logo.svg": 4716,
	"./logo-first.svg": 4638,
	"./logo-second.svg": 3178,
	"./modal-thanks.png": 4517,
	"./projects/bafsy.svg": 1296,
	"./projects/carbonfay.svg": 6822,
	"./projects/promokit.svg": 694,
	"./projects/promoprovod.svg": 2233,
	"./rules/mobile-rules-1.png": 7504,
	"./rules/mobile-rules-2.png": 8608,
	"./rules/mobile-rules-3.png": 7411,
	"./rules/rules-1.png": 4863,
	"./rules/rules-2.png": 6855,
	"./rules/rules-3.png": 3385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;